import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATES_PENDING = Symbol('affiliates.pending');

export const AFFILIATES_PENDING_ROUTE_NAME = Symbol('affiliates.pending');
export const AFFILIATES_PENDING_LIST_ROUTE_NAME = Symbol('affiliates.pending.list');

export const AFFILIATES_PENDING_LIST_URL = 'admin/affiliates/list_waiting_for_approval';
export const AFFILIATES_PENDING_LIST_QUERY_KEY = 'affiliates.pending.list';

export const AFFILIATES_PENDING_COUNT_URL = 'admin/affiliates/confirmed_awaiting_count';
export const AFFILIATES_PENDING_COUNT_QUERY_KEY = 'affiliates.pending.count';

export const AFFILIATES_PENDING_REJECT_URL = 'admin/affiliates/:id/reject_request';
export const AFFILIATES_PENDING_REJECT_MUTATION_KEY = 'affiliates.pending.reject';

export const AFFILIATES_PENDING_PROFILE_ROUTE_NAME = Symbol('affiliates.pending.profile');
export const AFFILIATES_PENDING_APPROVE_ROUTE_NAME = Symbol('affiliates.pending.approve');

export const AFFILIATES_PENDING_APPROVE_URL = 'admin/affiliates/:id/approval_request';
export const AFFILIATES_PENDING_APPROVE_MUTATION_KEY = 'affiliates.pending.approve';

export const AFFILIATES_PENDING_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATES_PENDING_AFFILIATES),
  REQUEST: new Permission(PermissionsList.admin.AFFILIATES_REQUEST),
  SELECT_MANAGER: new Permission(PermissionsList.admin.AFFILIATES_SELECT_MANAGER),
};
